import React from "react";

import { Text } from "@performyard/py-components";

import Button from "../../../../components/Button";
import EmployeePicker, { type SingleEmployee } from "../../../../components/EmployeePicker";
import Input from "../../../../components/Inputs/InputText";
import FormModal from "../../../../components/Modal/Templates/FormModal";
import Spacer from "../../../../components/Spacer";

import css from "./Workspaces.module.scss";

type WorkspaceFormModalProps = {
	handleSubmit: () => void;
	handleClose: () => void;
	strings: {
		title: string;
		cancel: string;
		submit: string;
	};
	state: {
		name: string;
		participant: SingleEmployee | null;
		isOpen: boolean;
		isPending: boolean;
		isParticipantEditable: boolean;
		error: {
			name?: { message: string };
			participant?: { message: string };
		};
	};
	updateForm: (form: { name?: string; participant?: SingleEmployee | null }) => void;
};

const WorkspaceFormModal = ({ handleSubmit, handleClose, strings, state, updateForm }: WorkspaceFormModalProps) => {
	return (
		<FormModal
			isOpen={state.isOpen}
			handleClose={handleClose}
			onSubmit={async (e) => {
				// Don't reload the page
				e.preventDefault();

				handleSubmit();
			}}
			title={
				<Text weight="semi-bold" size="sub-heading">
					{strings.title}
				</Text>
			}
			buttons={[
				<Button key="cancel" size="large" onClick={handleClose}>
					{strings.cancel}
				</Button>,
				<Button key="save" size="large" isRequesting={state.isPending} color="green" submit>
					{strings.submit}
				</Button>,
			]}
		>
			<Input
				label="Meeting Workspace Name"
				value={state.name}
				onChange={(value) => updateForm({ name: value.trimStart() })}
				placeholder="Meeting Workspace Name Here"
				autoFocus
				errorMessage={
					state.error.name?.message
						? state.error.name.message
						: state.name.length > 280
							? "Name cannot exceed 280 characters"
							: ""
				}
				animatedError
				testId="workspace-name-input"
				iconPlacement="right"
				clearable={true}
			/>
			<Spacer height={2} />
			<EmployeePicker
				label="Participant"
				value={state.participant ?? ""}
				onChange={(newEmployeeValue) => {
					// Affirm that newEmployeeValue is of type SingleEmployeeSchema
					let singleNewEmployeeValue = newEmployeeValue;
					if (Array.isArray(newEmployeeValue)) {
						singleNewEmployeeValue = newEmployeeValue[0];
					}
					if (singleNewEmployeeValue && !("value" in singleNewEmployeeValue)) {
						return;
					}
					updateForm({ participant: singleNewEmployeeValue ?? null });
				}}
				errorMessage={state.error.participant?.message}
				excludeCurrentUser={true}
				disabled={!state.isParticipantEditable}
				className={!state.isParticipantEditable ? css.disabledEmployeePicker : undefined}
			/>
		</FormModal>
	);
};

export default WorkspaceFormModal;
